// config.js

const phpPath = "https://eleven.fit/php";

// #added Meta Pixel: vacío = apagado. El ID es público; el token de la Conversions API NO va aquí (php/meta-config.php) 2/11/26 TG
const metaPixelId = "2726185854500550";

export { phpPath, metaPixelId };